function comparePage() {
  if (window.comparePageInitialized) return;
  window.comparePageInitialized = true;

  document.querySelectorAll(".js-add-to-compare").forEach(function (el) {
    var productHandle = el.getAttribute("data-product-handle") + ",";
    var compare = localStorage.getItem("compare") || "";
    if (compare.indexOf(productHandle) >= 0) {
      el.classList.add("compared");
      var span = el.querySelector("span");
      if (span) span.textContent = el.getAttribute("data-added");
    }
  });

  document.body.addEventListener("click", function (e) {
    var btn = e.target.closest(".js-add-to-compare");
    if (!btn) return;

    if (!btn.classList.contains("compared")) {
      var productHandle = btn.getAttribute("data-product-handle");
      var span = btn.querySelector("span");
      if (span) span.textContent = btn.getAttribute("data-added");

      var getComparedProducts = localStorage.getItem("compare") || "";
      getComparedProducts = getComparedProducts.replace(productHandle + ",", "");
      localStorage.setItem("compare", getComparedProducts + productHandle + ",");

      btn.classList.add("compared");

      e.preventDefault();
    }
  });

  var compareTable = document.querySelector(".js-compare-body");
  if (compareTable) {
    var compare = localStorage.getItem("compare") || "";
    var compareContent = "";

    if (compare !== "") {
      var compareProducts = compare.split(",");
      var requests = [];

      compareProducts.forEach(function (handle) {
        if (handle !== "") {
          var request = fetch("/products/" + handle + ".js")
            .then(function (res) {
              if (!res.ok) throw new Error("Product not found");
              return res.json();
            })
            .then(function (product) {
              var first_column =
                '<td><div class="wishlist__product">' +
                '<div class="wishlist-product__image">' +
                '<a href="' + product.url + '">' +
                '<img alt="Image" src="' + product.featured_image + '" class="lazyload" />' +
                '</a></div>' +
                '<h3 class="wishlist-product__title"><a href="' + product.url + '">' + product.title + '</a></h3>' +
                '</div></td>';

              var second_column =
                '<td><div class="wishlist-product__price">' +
                Shopify.formatMoney(product.price) +
                '</div></td>';

              var third_column = product.available
                ? '<td><div class="wishlist-product__status wishlist-product__status--in-stock">' + compareTable.getAttribute("data-in-stock") + '</div></td>'
                : '<td><div class="wishlist-product__status wishlist-product__status--stock-out">' + compareTable.getAttribute("data-out-of-stock") + '</div></td>';

              var fourth_column =
                '<td><a href="' + product.url + '" class="fourth-button">' +
                compareTable.getAttribute("data-add-to-cart") +
                '</a></td>';

              var fifth_column =
                '<td><div class="wishlist-product__delete">' +
                '<a href="#" class="js-delete-product-compare" data-product-handle="' + product.handle + '">' +
                ' <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lnil lnil-close" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg></a></div></td>';

              compareContent += "<tr>" + first_column + second_column + third_column + fourth_column + fifth_column + "</tr>";
            })
            .catch(function () {
              console.warn("Error loading product:", handle);
            });

          requests.push(request);
        }
      });

      Promise.all(requests).then(function () {
        if (compareContent === "") {
          compareContent = '<tr><td colspan="5">' + compareTable.getAttribute("data-compare-empty") + "</td></tr>";
        }
        compareTable.innerHTML = compareContent;
      });
    } else {
      compareTable.innerHTML = '<tr><td colspan="5">' + compareTable.getAttribute("data-compare-empty") + "</td></tr>";
    }

    document.body.addEventListener("click", function (e) {
      var delBtn = e.target.closest(".js-delete-product-compare");
      if (!delBtn) return;

      e.preventDefault();
      var row = delBtn.closest("tr");
      if (row) row.remove();

      var productHandle = delBtn.getAttribute("data-product-handle");
      var getCompareProducts = localStorage.getItem("compare") || "";
      getCompareProducts = getCompareProducts.replace(productHandle + ",", "");
      localStorage.setItem("compare", getCompareProducts);
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  comparePage();
});